const ROUTES = {
  LOGIN: '/',
  LEARN: '/learn',
  LIVE: '/live',
  ASSESSMENT: '/assessment',
  CHAPTERS: '/chapters',
  TOPICS: '/topics',
  MATERIAL: '/materials',
  COMPLETED_SESSIONS: '/completedSessions',
  TESTINSTRUCTIONS: '/instructions',
  TEST: '/test',
  REGISTER: '/register',
  PACKAGE: '/package/:name',
  RESULTS: '/results',
  USER: '/user',
  SUPERADMIN: '/superAdmin',
  BRANCHADMIN: '/branchAdmin',
  INSTITUTEADMIN: '/instituteAdmin',
  TEACHER: '/teacher',
  STUDENT: '/student',
  DASHBOARD: '/dashboard',
  RESET_PASSWORD: '/resetPassword',
  PRACTICE_TEST: '/practiceTest',
  USER_DETAIL: '/userDetail',
  NEW_USER: '/newUser',
  BRANCH_LIST: '/branchList',
  BRANCH_ADD: '/addBranch',
  BRANCH_EDIT: '/editBranch',
  PUBLISH_LIST: '/publishList',
  PUBLISH_MATERIAL_ADD: '/addPublishMaterial',
  PUBLISH_MATERIAL_EDIT: '/editPublishMaterial',
  BRANCH_DETAIL: '/branchDetail',
  SESSION_LIST: '/sessionList',
  VIEW_SESSION: '/viewSession',
  EDIT_SESSION: '/editSession',
  ADD_SESSION: '/addSession',
  BATCH_LIST: '/batchList',
  QUESTIONLIST: '/questionList',
  ADDQUESTION: '/addQuestion',
  BATCH_ADD: '/addBatch',
  TEST_LIST: '/testList',
  TEST_RESULTS: '/testResults',
  PENDING_REQUESTS: '/pendingRequests',
  ADMIN_MATERIAL: '/material',
  ADD_MATERIAL: '/addMaterial',
  EVALUATE: '/evaluate',
  REVIEW: '/review',
  TESTS: '/tests',
  REVIEWQUESTIONS: '/reviewQuestions',
  INSTITUTE: '/institute',
  ADD_INSTITUTE: '/addInstitute',
  EDIT_INSTITUTE: '/editInstitute',
  INSTITUTE_DETAIL: '/instituteDetail',
  CREATE_TEST: '/createTest',
  COURSELIST: '/courseList',
  ADDCOURSE: '/addCourse',
  TESTSETTING: '/testSetting',
  EDIT_BATCH: '/editBatch',
  VIEW_BATCH: '/viewBatch',
  VIEW_COURSE: '/viewCourse',
  EDIT_COURSE: '/editCourse',
  STUDENT_BULK_ENTRY: '/bulkEntry',
  PURCHASE_COURSE: '/purchaseCourse',
  ASSIGNMENT: '/assignment',
  STUDENT_ACTIVITY: '/studentActivity',
  LESSON_PLANE: '/lessonPlane',
  LEARN_SESSION: '/learnSession',
  ASSIGNLEARN_SESSION: '/assignLearnSession',
  CACHE: '/cache',
  STUDENT_REGISTER: '/studentRegister',
  APPLY_LEAVE: '/applyLeave',
  LEAVE_DETAILS: '/leaveDetails',
  VIEW_LEAVE_STATUS: '/viewLeaveStatus',
  CREATE_LEAVE: '/createLeave',
  LEAVE_MASTER_DETAILS: '/leaveMasterDetails',
  QR_LIST: '/qrList',
  WEBCAM_SCANNER: '/webcamScanner',
  QRVIDEO: '/qrVideo',
  DAILY_TEST: '/dailyTest',
  ATTEMPETD_TEST: '/attemptedTest'
}

export default ROUTES
